<template>
	<div class="page">
		<div>
			<header-block bgcolor="#FCE5D4ff" title="Vouchers"></header-block>
			<CustomerLoadWait :customer="customer && vouchersSummary" :cardBlocks="true" :withTopCard="true" />
			<div v-if="customer && vouchersSummary">

			<div class="balanceHeader">
				<SavingsCard 
					:items="savingsItems"
					:formatter="formatter"
				/>
			</div>
				<!-- Parent div to allow odd/even css selectors -->
				<div>
					<div :class="'hubItemWrapper'" v-for="a in vouchersSummary.merchantGroups" :key="a.id">
						<AccountButton 
						:showProvider="false" 
						@click="handleClick(a)" 
						:title="a.merchantName" 
						:icon="a.customerVouchers[0].discount.cardUrl" 
						:balance="formatter.format(a.totalBalance)"
						:voucherCount="a.totalVouchers"></AccountButton>
					</div>
					<div :class="'hubItemWrapper'" v-if="vouchersSummary.merchantGroups.length == 0">
						<AccountButton href="/#/ShopVouchers" :isAddButton="true"></AccountButton>
					</div>
				</div>
				<div style="clear:both; margin-bottom: 10px"></div>
			</div>
		</div>
		<div class="bottom-buttons">
			<MGButton :arrow="true" text="Shop Vouchers" :stacked="true" :fullWidth="true" @click="navigateToShopVouchers()"/>
			<MGButton text="Archived" :outline="true" :stacked="true" :fullWidth="true" @click="navigateToArchived()" />
		</div>
	</div>
	
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import AccountButton from './elements/AccountButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import SavingsCard from './elements/SavingsCard.vue';
import Helpers from '../mixins/Helpers';
import MGButton from './elements/MGButton.vue';

export default {
	mixins: [Services, Helpers],
	components: { CustomerLoadWait, AccountButton, HeaderBlock, SavingsCard, MGButton },
	data() {
		return {
			balance: 0,
			selectedMerchant: null,
			merchantVouchers: []
		}
	},
	computed: {
		savingsItems() {
			return [
				{
					value: this.vouchersSummary.currentSavings,
					label: 'Saved to spend'
				},
				{
					value: this.vouchersSummary.savedThisMonth,
					label: 'Saved this month'
				},
				{
					value: this.vouchersSummary.allTimeSavings,
					label: 'All time savings'
				}
			];
		},
	},
	methods: {
		onLoad: async function() {
			this._getCustomer(() => {
				this._getCustomerVouchersSummary();
			});
		},
		navigateToArchived: function() {
			this.$router.push('/MyVouchers/Archived/Merchants');
		},
		navigateToShopVouchers: function() {
			this.$router.push('/shopvouchers');
		},
		handleClick(merchant) {
			this.$router.push('/MyVouchers/Merchants/' + merchant.merchantId + '?archive=false');
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.bottom-buttons {
	margin-top: auto;
	padding: 0px 0 30px 0;
}

.title {
	font-size: 14px;
	font-weight: bold;
}

.info-header {
	background-color: #ffffff44;
	border-radius: 16px;
	margin:30px;
	padding: 10px;
	margin-top: 0px;
}

.button-row {
	padding:0px;
}
.button-col {
	padding-top:0px;
}

.balance-col {
	padding-left: 20px;
	font-size: 16px;
	text-align: left;
	margin-left: 20px;
}

.balance-col-right {
	padding-left: 20px;
	font-size: 16px;
	text-align: right;
	margin-right: 30px;
}

.balance-title {
	font-size: 12px !important;
	margin-bottom: 0px;
	font-weight: lighter;
}

.divider {
	width: 48px;
	margin-bottom: 8px;
	margin-top: 8px;
	margin-right: auto;
	margin-left: auto;
	background: var(--Keyline, rgba(51, 40, 71, 0.10));
	height: 4px;
	border-radius: 4px;
}

.usedVouchers {
	padding-left: 10px;
	padding-right: 10px;
}

.topTabButton
{
	margin-top: 0px;
}

.topMenuCol {
	padding-left: 5px;
	padding-right: 5px;
}

.topMenuRow
{
	margin-left: -5px;
	margin-right: -5px;
	margin-bottom: 15px;
}

.balanceHeader {
	background: linear-gradient(202deg, #FCE5D4 49.85%, #E0C5C8 100%);
	clear:both;
	margin-left: -30px;
	margin-right: -30px;
	margin-top: -138px;
	margin-bottom: -80px;
	color: var(--text-color);
	font-size: 15px;
	text-align: center;
	padding-top: 150px;
	padding-bottom: 75px;
	p{
		font-size: 48px;
		font-family: 'Gotham-Heavy';
		margin-top: 0px;
	};
	.small {
		font-size: 10px;
		margin-top: -40px;
	}
}

.totals 
{
	text-align: center;
	padding-bottom: 20px;
	font-weight: bold;
	font-size: 15px;
	span {
		font-size: 30px;
		margin-top: 20px;
	}
}

</style>
